import React from "react"
import '@westernunion/css/lang/wuds.he.css'
const LanguageHE = () => {
    return (
        <></>
      )
}
export default LanguageHE
